import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { Chart } from "chart.js";
import { ReactNode } from "react";
import { useDashboardYear } from "../../hooks/useDateRange";
import styles from "./Widget.module.scss";

Chart.defaults.font.family =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu"';

export interface WidgetProps {
  title?: string;
  loading?: boolean;
  tooltip?: ReactNode;
  icon?: ReactNode;
  children?: ReactNode;
  contentClassName?: string;
  topRight?: ReactNode;
  showDate?: boolean;
  footer?: ReactNode;
}

export default function Widget({
  title,
  icon,
  tooltip,
  children,
  contentClassName,
  topRight,
  showDate,
  footer,
}: WidgetProps) {
  const { year } = useDashboardYear();

  return (
    <div className={styles.Widget}>
      <div className={styles.headerContentContainer}>
        {(title || topRight) && (
          <div className={styles.header}>
            {icon && <div className={styles.icon}>{icon}</div>}
            <div className={styles.title}>
              <h2>
                {title}
                {tooltip && (
                  <Tooltip
                    className={styles.tooltip}
                    title={tooltip}
                  >
                    <InfoCircleOutlined />
                  </Tooltip>
                )}
              </h2>
              {showDate !== false && <span className={styles["date-range"]}>{year}</span>}
            </div>
            <div className={styles["top-right"]}>{topRight}</div>
          </div>
        )}
        {children && <div className={`${styles.content} ${contentClassName}`}>{children}</div>}
      </div>
      {footer && <div className={`${styles.footer} ${contentClassName}`}>{footer}</div>}
    </div>
  );
}
